export const MenuMockData = [
  {
    collectionName: 'Proteins',
    menuItems: [
      {
        id: 1,
        label: 'Chicken',
      },
      {
        id: 2,
        label: 'Milk',
      },
      {
        id: 3,
        label: 'Turkey',
      },
      {
        id: 4,
        label: 'Cheese',
      },
      {
        id: 5,
        label: 'Duck',
      },
      {
        id: 6,
        label: 'Yogurt',
      },
      {
        id: 7,
        label: 'Eggs',
      },
      {
        id: 8,
        label: 'Soy Milk',
      },
      {
        id: 9,
        label: 'Fish',
      },
      {
        id: 10,
        label: 'Salt',
      },
      {
        id: 11,
        label: 'Pepper',
      },
      {
        id: 12,
        label: 'Pork',
      },
      {
        id: 13,
        label: 'Quinoa pasta',
      },
      {
        id: 14,
        label: 'Venison',
      },
      {
        id: 15,
        label: 'Oat flour',
      },
    ],
  },
  {
    collectionName: 'Vegetables',
    menuItems: [
      {
        id: 16,
        label: 'Broccoli',
      },
      {
        id: 17,
        label: 'Peas',
      },
      {
        id: 18,
        label: 'Cauliflower',
      },
      {
        id: 19,
        label: 'Fresh Herbs',
      },
      {
        id: 20,
        label: 'Celery',
      },
      {
        id: 21,
        label: 'Corn',
      },
      {
        id: 22,
        label: 'Green Bean',
      },
      {
        id: 23,
        label: 'Cucumber',
      },
      {
        id: 24,
        label: 'Sweet Potatoes',
      },
      {
        id: 25,
        label: 'Eggplant',
      },
      {
        id: 26,
        label: 'Tomatoes',
      },
      {
        id: 27,
        label: 'Carrot',
      },
      {
        id: 28,
        label: 'Mushroom',
      },
      {
        id: 29,
        label: 'Lettuce',
      },
      {
        id: 30,
        label: 'Kale',
      },
      {
        id: 31,
        label: 'Avocado',
      },
    ],
  },
  {
    collectionName: 'Fruits',
    menuItems: [
      {
        id: 32,
        label: 'Apple',
      },
      {
        id: 33,
        label: 'Cherries',
      },
      {
        id: 34,
        label: 'Banana',
      },
      {
        id: 35,
        label: 'Kiwi Fruit',
      },
      {
        id: 36,
        label: 'Blueberries',
      },
      {
        id: 37,
        label: 'Melon',
      },
      {
        id: 38,
        label: 'Mango',
      },
      {
        id: 39,
        label: 'Peaches',
      },
      {
        id: 40,
        label: 'Papaya',
      },
      {
        id: 41,
        label: 'Orange',
      },
    ],
  },
];
